import * as React from "react";
import { Button, type ButtonProps } from "./button.js";
import { cn } from "../lib/utils.js";

export interface IconButtonProps extends Omit<ButtonProps, "size" | "aria-label"> {
  "aria-label": string;
  size?: "default" | "sm";
}

/** Icon-only control for universally understood, repeated actions. */
export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, size = "default", title, ...props }, ref) => (
    <Button
      ref={ref}
      size="icon"
      title={title ?? props["aria-label"]}
      className={cn(size === "sm" && "sm:h-8 sm:w-8", className)}
      {...props}
    />
  ),
);
IconButton.displayName = "IconButton";
